export default function ItemStockView(){
    return (
        <section>
        <h2 class="top_title_h2">在庫表記についてのご注意</h2>
        <div class="item_stock_div">
        <div class="item_stock_svg_box">
        <div class="item_stock_svg item_stock_tablet"></div>
        <div class="item_stock_svg item_stock_lefT_light"></div>
        <div class="item_stock_svg item_stock_shop"></div>
        <div class="item_stock_svg item_stock_left"></div>
        <div class="item_stock_svg item_stock_car"></div>
        </div>
        <p class="item_stock_p_sub">当サイトの在庫表示は福山ラジコンセンターの店舗在庫と共有しており当店の在庫管理システム上店頭在庫と連動したリアルタイムのものではありません</p>
        <p class="item_stock_p_sub">サイト上在庫がある場合の商品が店頭販売で売り切れてしまっている場合があります売り切れの商品に関しては1週間程度で入荷出来るものに関してはそのまま入荷待ちという事で書士させて頂きます。</p>
        <p class="item_stock_p_sub">それ以上の時間がかかる商品はメールでお客様にご連絡させていただきます。お客様にご迷惑をお掛けしない様に努めてまいりますが、ご理解の程宜しくお願い致します。</p>
        </div>
    </section>
    );
}